import { ref } from "vue";

import { defineStore } from "pinia";

import { uniqueId } from "lodash-es";

/**
 * A low-level non-heavy unique id generator for notify
 *
 * @returns A unique numbers.
 */
function generateUniqueId() {
  return uniqueId();
}

export const useNotifyStore = defineStore("notify", () => {
  const notifications = ref([]);

  function ADD_NOTIFY(notify) {
    // give notify a unique id
    notify = {
      id: generateUniqueId(),
      ...notify,
    };

    // add the notify to the list
    notifications.value.unshift(notify);
  }

  function REMOVE_NOTIFY(id) {
    // remove the notify by filtering by id
    notifications.value = notifications.value.filter((n) => n.id !== id);
  }

  return {
    notifications,
    ADD_NOTIFY,
    REMOVE_NOTIFY,
  };
});
